/**
 * Variant Redirects for Dubious Doodles
 * ======================================
 * Redirects specific product variant URLs to new product listings.
 * Place this file in your Shopify theme's Assets folder.
 *
 * Reference it in theme.liquid just before </body>:
 *   <script src="{{ 'variant-redirects.js' | asset_url }}" defer></script>
 *
 * TO ADD A NEW REDIRECT:
 *   1. Find the old product's URL path (everything after your domain).
 *   2. Find the variant ID(s) from the ?variant= parameter.
 *   3. Add an entry below following the existing pattern.
 *   4. Save the file in Shopify's code editor.
 *
 * Example:
 *   "/products/old-product-handle": {
 *     "OLD_VARIANT_ID": "/products/new-product-handle",
 *     "ANOTHER_VARIANT_ID": "/products/new-product-handle"
 *   }
 */

(function() {
  var defined_redirects = {

    "/products/hidden-message-coffee-mug-what-the-fuck": {
      "44822046212165": "/products/hidden-profanity-mug-gray-stripes-wtf",
      "44822046277701": "/products/hidden-profanity-mug-gray-stripes-wtf"
    },

        "/products/no-time-for-bullshit-hidden-message-mug": {
      "44848971022405": "/products/no-time-for-bullshit-hidden-message-mug-gray",
      "44848971087941": "/products/no-time-for-bullshit-hidden-message-mug-gray"
    }

    // Add more products below. Separate each block with a comma:
    //
    // ,"/products/another-old-product": {
    //   "44848971022405": "/products/its-new-home",
    //   "44848971087941": "/products/its-new-home"
    // }

  };

  var path = window.location.pathname.toLowerCase();
  var params = new URLSearchParams(window.location.search);
  var variantId = params.get("variant");

  if (variantId && defined_redirects[path] && defined_redirects[path][variantId]) {
    window.location.replace(defined_redirects[path][variantId]);
  }
})();